import { gql } from '@parkchirp/api-client';

export const LIST_EVENT_VENUES = gql`
    query listEventVenues($facilityId: String!) {
        listEventVenues(facilityId: $facilityId) {
            id
            name
        }
    }
`;

export const LIST_VENUE_EVENT_TYPE_KEYS = gql`
    query listVenueEventTypeKeys(
        $facilityId: String!
        $venueId: Int!
        $hourlyCategory: String!
        $defaultEventRateId: Int
    ) {
        listVenueEventTypeKeys(
            facilityId: $facilityId
            venueId: $venueId
            hourlyCategory: $hourlyCategory
            defaultEventRateId: $defaultEventRateId
        )
    }
`;

export const CREATE_DEFAULT_EVENT_RATE = gql`
    mutation createDefaultEventRate($input: CreateDefaultEventRateInput!) {
        createDefaultEventRate(input: $input)
    }
`;

export const UPDATE_DEFAULT_EVENT_RATE = gql`
    mutation updateDefaultEventRate($input: UpdateDefaultEventRateInput!) {
        updateDefaultEventRate(input: $input)
    }
`;

export const DELETE_DEFAULT_EVENT_RATE = gql`
    mutation deleteDefaultEventRate($id: Int!) {
        deleteDefaultEventRate(id: $id)
    }
`;

export const LIST_DEFAULT_EVENT_RATES = gql`
    query listDefaultEventRates(
        $facilityId: String!
        $hourlyCategory: String!
        $limit: Int!
        $offset: Int!
        $filters: [Filter]
        $order: SortOrder
    ) {
        listDefaultEventRates(
            facilityId: $facilityId
            hourlyCategory: $hourlyCategory
            limit: $limit
            offset: $offset
            filters: $filters
            order: $order
        ) {
            count
            defaultEventRates {
                id
                templateId
                venueId
                venueName
                eventTypeKey
                offsetBefore
                offsetAfter
                pricingTiers {
                    id
                    inventory
                    grossPrice
                    sortOrder
                }
            }
        }
    }
`;

export const GET_DEFAULT_EVENT_RATES_CSV = gql`
    query getDefaultEventRatesCSV(
        $facilityId: String!
        $hourlyCategory: String!
        $filters: [Filter]
        $order: SortOrder
    ) {
        getDefaultEventRatesCSV(
            facilityId: $facilityId
            hourlyCategory: $hourlyCategory
            filters: $filters
            order: $order
        ) {
            url
        }
    }
`;

export const LIST_HOURLY_ACCOUNTS_V2 = gql`
    query listHourlyAccounts(
        $organizationId: Int,
        $limit: Int!,
        $offset: Int!,
        $filters: [Filter],
        $order: SortOrder,
    ) {
        listHourlyAccounts(
            organizationId: $organizationId,
            limit: $limit,
            offset: $offset,
            filters: $filters,
            order: $order,
        ) {
            count,
            hourlyAccounts {
                id,
                pid,
                name,
                description,
                facility {
                    id,
                    facilityName,
                    facilityNumber,
                }
                organizationSettings {
                    organizationId,
                    name
                }
            }
        }
    }
`;

export const GET_HOURLY_ACCOUNT_V2 = gql`
    query getHourlyAccount(
        $id: String!
    ) {
        getHourlyAccount(
            id: $id
        ) {
            id,
            pid,
            name,
            description,
            facility {
                id,
                facilityName,
                facilityNumber,
            },
            organizationSettings {
                organizationId,
                name
            }
            hourlyAccountUserGroups {
                id
                masterPolicy,
                userGroup {
                    name
                    functionGroups {
                        functionGroup {
                            id,
                            name,
                            description
                        }
                    }
                }
                hourlyAccountUsers {
                    user {
                        firstName,
                        lastName,
                        email,
                    }
                }
                validationMethods {
                	id,
                	webValidation,
                 	qrValidation,
                  	validationMethod {
                   		id,
                     	text,
                      	startsOn,
                       	expiresOn,
                        hourlyValidation {
                        	id
                         	name
                          	startsOn
                           	expiresOn
                         	modifier {
                          		type
                            	value
	                            rate {
	                            	id
	                             	name
	                            }
                            }
                        }
                    }
                }
            }
            hourlyAccountConfigs {
                id
                feature
                config
            }
        }
    }
`;

export const CREATE_HOURLY_ACCOUNT_V2 = gql`
    mutation createHourlyAccount(
        $input: HourlyAccountInput!
    ) {
        createHourlyAccount(
            input: $input
        )
    }
`;

export const UPDATE_HOURLY_ACCOUNT_V2 = gql`
    mutation updateHourlyAccount(
        $input: HourlyAccountInput!
    ) {
        updateHourlyAccount(
            input: $input
        )
    }
`;

export const DELETE_HOURLY_ACCOUNT_V2 = gql`
    mutation deleteHourlyAccount(
        $id: String!
    ) {
        deleteHourlyAccount(
            id: $id,
        )
    }
`;

export const LIST_HOURLY_ACCOUNT_USERS_V2 = gql`
    query listHourlyAccountUsers(
        $organizationId: Int,
        $hourlyAccountId: String,
        $limit: Int!,
        $offset: Int!,
        $filters: [Filter],
        $order: SortOrder,
    ) {
        listHourlyAccountUsers(
            organizationId: $organizationId,
            hourlyAccountId: $hourlyAccountId,
            limit: $limit,
            offset: $offset,
            filters: $filters,
            order: $order,
        ) {
            count,
            hourlyAccountUsers {
                id,
                active,
                user {
                    userId,
                    firstName,
                    lastName,
                    email,
                }
                hourlyAccount {
                    id,
                    pid,
                    name,
                    description,
                    facility {
                        id,
                        facilityName,
                        facilityNumber
                    }
                    organizationSettings {
                        organizationId,
                        name
                    }
                }
                hourlyAccountUserGroup {
                    id
                    masterPolicy
                    userGroup {
                        name,
                        description
                        functionGroups {
                            functionGroup {
                                id
                                name
                                description
                            }
                        }
                    }
                    validationMethods {
                    	id,
                    	webValidation,
                     	qrValidation,
                      	validationMethod {
                       		id,
                         	text,
                          	startsOn,
                           	expiresOn,
                            hourlyValidation {
                            	id
                             	name
                              	startsOn
                               	expiresOn
                             	modifier {
                              		type
                                	value
	                            rate {
	                            	id
	                             	name
	                            }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_HOURLY_ACCOUNT_USER_V2 = gql`
    query getHourlyAccountUser(
        $id: String!
    ) {
        getHourlyAccountUser(
            id: $id
        ) {
            id,
            active,
            user {
                userId
                firstName
                lastName
                email
            }
            hourlyAccount {
                id
                pid
                name
                description
                facility {
                    id
                    facilityName
                    facilityNumber
                }
                organizationSettings {
                    name
                    organizationId
                }
            }
            hourlyAccountUserGroup {
                id
                userGroup {
                    name,
                    description,
                    functionGroups {
                        functionGroup {
                            id
                            name,
                            description
                        }
                    }
                }
                validationMethods {
                	id,
                	webValidation,
                 	qrValidation,
                  	validationMethod {
                   		id,
                     	text,
                      	startsOn,
                       	expiresOn,
                        hourlyValidation {
                        	id
                         	name
                          	startsOn
                            expiresOn
                         	modifier {
                          		type
                            	value
	                            rate {
	                            	id
	                             	name
	                            }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const CREATE_HOURLY_ACCOUNT_USER_V2 = gql`
    mutation createHourlyAccountUser(
        $input: HourlyAccountUserInput!
    ) {
        createHourlyAccountUser(
            input: $input
        )
    }
`;

export const UPDATE_HOURLY_ACCOUNT_USER_V2 = gql`
    mutation updateHourlyAccountUser(
        $input: HourlyAccountUserInput!
    ) {
        updateHourlyAccountUser(
            input: $input
        )
    }
`;

export const DELETE_HOURLY_ACCOUNT_USER_V2 = gql`
    mutation deleteHourlyAccountUser(
        $id: String!
    ) {
        deleteHourlyAccountUser(
            id: $id,
        )
    }
`;

export const LIST_HOURLY_VALIDATIONS_BY_FACILITY_ID_V2 = gql`
	query listHourlyValidationsByFacilityId(
        $limit: Int!,
        $offset: Int!,
        $filters: [Filter],
        $order: SortOrder!,
        $queryContext: FacilityQueryContextEnum,
        $facilityId: String!,
    ) {
        listHourlyValidationsByFacilityId(
            limit: $limit,
            offset: $offset,
            filters: $filters,
            order: $order,
            queryContext: $queryContext,
            facilityId: $facilityId
        ) {
        	id
         	text
          	validation {
           		name
             	modifier {
              		type
                	value
                 	rate {
                 		name
                   }
              }
            }
        }
    }
`;

export const LIST_HOURLY_ACCOUNT_USER_GROUPS_V2 = gql`
    query listHourlyAccountUserGroups(
        $organizationId: Int,
        $limit: Int!,
        $offset: Int!,
        $filters: [Filter],
        $order: SortOrder,
    ) {
        listHourlyAccountUserGroups(
            organizationId: $organizationId,
            limit: $limit,
            offset: $offset,
            filters: $filters,
            order: $order,
        ) {
            count,
            hourlyAccountUserGroups {
                id,
                masterPolicy,
                userGroup {
                    name
                }
                hourlyAccount {
                    id,
                    pid,
                    name,
                    description,
                    facility {
                        id,
                        facilityName,
                        facilityNumber
                    }
                    organizationSettings {
                        organizationId,
                        name
                    }
                }
            }
        }
    }
`;

export const GET_HOURLY_ACCOUNT_USER_GROUP_V2 = gql`
    query getHourlyAccountUserGroup(
        $id: String!
    ) {
        getHourlyAccountUserGroup(
            id: $id
        ) {
            id
            masterPolicy,
            hourlyAccount {
                id,
                pid,
                name,
                facility {
                    id
                }
            }
            userGroup {
                name
                functionGroups {
                    functionGroup {
                        id
                        name,
                        description
                    }
                }
            }
            hourlyAccountUsers {
                user {
                    firstName,
                    lastName,
                    email,
                }
            }
            validationMethods {
            	id,
            	webValidation,
             	qrValidation,
              	validationMethod {
               		id,
                 	text,
                  	startsOn,
                   	expiresOn,
                    hourlyValidation {
                    	id
                     	name
                      	startsOn
                        expiresOn
                     	modifier {
                      		type
                        	value
	                            rate {
	                            	id
	                             	name
	                            }
                        }
                    }
                }
            }
        }
    }
`;

export const CREATE_HOURLY_ACCOUNT_USER_GROUP_V2 = gql`
    mutation createHourlyAccountUserGroup(
        $input: HourlyAccountUserGroupInput!
    ) {
        createHourlyAccountUserGroup(
            input: $input
        )
    }
`;

export const UPDATE_HOURLY_ACCOUNT_USER_GROUP_V2 = gql`
    mutation updateHourlyAccountUserGroup(
        $input: HourlyAccountUserGroupInput!
    ) {
        updateHourlyAccountUserGroup(
            input: $input
        )
    }
`;

export const DELETE_HOURLY_ACCOUNT_USER_GROUP_V2 = gql`
    mutation deleteHourlyAccountUserGroup(
        $id: String!
    ) {
        deleteHourlyAccountUserGroup(
            id: $id,
        )
    }
`;

export const LIST_HOURLY_RATES_BY_CITY = gql`
  query listHourlyRatesByCity($cityId: String!, $category: String!) {
    listHourlyRatesByCity(cityId: $cityId, category: $category) {
      id
      name
    }
  }
`;
